// If window.Worker is available it means we are creating
// the asset resources in a WebWorker, so they run
// in the background and we don't need the timeouts
// to prevent the ui-loop from blocking
export const setTimeoutMaybe = (cb, duration) => {
  if (window.Worker) {
    cb();
  } else {
    setTimeout(cb, duration);
  }
};
